import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private activeRequests = 0;
  private readonly loadingSubject = new Subject<boolean>();

  public loading = this.loadingSubject.asObservable();

  startLoading(): void {
    this.activeRequests++;
    this.update();
  }

  stopLoading(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    this.update();
  }

  private update(): void {
    this.loadingSubject.next(this.activeRequests > 0);
  }

  handleItems(): Observable<boolean> {
    return this.loading;
  }
}
